<div class="floating-btn-container" style="right: 10px;top: 10px;">
  <div class="popup-floating-btn" [class.cart]="type == 'Cart'" [class.has-new]="hasNew" [class.opened]="opened" [ngStyle]="{'background-color': color}"
  [mdePopoverTriggerFor]="appPopover" 
  mdePopoverTriggerOn="click" 
  #popoverTrigger="mdePopoverTrigger"
  [mdePopoverBackdropCloseOnClick]="true"
  (opened)="togglePopover(true)"
  (closed)="togglePopover(false)" ></div>
</div>

<!-- material popover -->
<mde-popover class="default" #appPopover="mdePopover" 
[mdePopoverOverlapTrigger]="false"
[mdePopoverCloseOnClick]="false" 
[mdeFocusTrapEnabled]="true">
  <div #mdePopover class="mde-popover-container broadcast-popover">
    <div class="container-loader" *ngIf="isBusy">
      <ngx-loading [show]="isBusy" [config]="loaderConfig"></ngx-loading>
    </div>
    <div class="mde-popover-header" [ngStyle]="{'background-color': color}">
      <p class="popover-title" [class.cart]="type == 'Cart'">{{title}}</p>
    </div>
    <div class="mde-popover-body" [class.full]="!broadcastAction">
        <app-detail [setComponentId]="detailId" [forceRefresh]="forceRefresh" [displayDetail]="opened" [fromBroadcast]="true"></app-detail>
    </div>
    <div class="mde-popover-footer" *ngIf="broadcastAction">
      <input #input placeholder="Type a message" (keyup.enter)="submit(input.value)" [disabled]="isBusy">
      <div class="submit-container">
        <div class="message-submit-icon" (click)="submit(input.value)"></div>
      </div>
    </div>
  </div>
</mde-popover>
